import React from 'react';
import DeleteIcon from '../../assets/icons/delete.svg';
import ViewMoreIcon from '../../assets/icons/view-more.svg';
import { gotoLocation } from '../../utils';

const Table = (props) => {
    return (
        <div className='flex column w-100'>
            <div className='flex justifyStart alignCenter table_header'>
                {props.tableHeaders.map((header, index) => (
                    <h3
                        key={index + 1}
                        className='table_header_element'
                        style={{
                            width:
                                index === 0
                                    ? props.screen === 'teachers'
                                        ? 140
                                        : 100
                                    : index === 1
                                    ? props.screen === 'students'
                                        ? 160
                                        : 160
                                    : index === 2
                                    ? 140
                                    : index === 3
                                    ? 100
                                    : index === 4
                                    ? 120
                                    : index === 5
                                    ? 110
                                    : index === 6
                                    ? 120
                                    : 100,
                            textAlign: 'right',
                        }}
                    >
                        {header}
                    </h3>
                ))}
            </div>

            <div className='flex column justifyStart alignCenter tabe_data_row'>
                {props.data.map((user, index) => (
                    <div className='flex justifyStart alignCenter table_row' key={index + 1}>
                        {props.screen === 'applicants' ? (
                            <h5 style={{ width: 100, textAlign: 'right' }}>{user.form_id}</h5>
                        ) : (
                            props.screen === 'students' && (
                                <h5 style={{ width: 100, textAlign: 'right' }}>
                                    {user.registration_id}
                                </h5>
                            )
                        )}
                        <h3 className='flex justifyStart alignCenter' style={{ width: 160 }}>
                            {user.name}
                        </h3>
                        <h3 className='flex justifyStart alignCenter' style={{ width: 140 }}>
                            {user.father_name}
                        </h3>
                        <h3 className='flex justifyStart alignCenter' style={{ width: 100 }}>
                            {user.department}
                        </h3>
                        <h3
                            className='flex justifyStart alignCenter'
                            style={{ width: 120, fontFamily: 'CircularStd', fontSize: 14 }}
                        >
                            {user.primary_phone_number}
                        </h3>
                        <h3
                            className='flex justifyStart alignCenter'
                            style={{ width: 120, fontFamily: 'CircularStd', fontSize: 14 }}
                        >
                            {user.cnic}
                        </h3>

                        <div
                            className='flex justifyStart alignCenter'
                            onClick={() => gotoLocation(`${props.link}?id=${user.id}`)}
                            style={{ width: 120 }}
                        >
                            <img src={ViewMoreIcon} alt='forward_icon' height={22} width={22} />
                            <h4 style={{ marginRight: 12 }}>تفصیلات دیکھیں</h4>
                        </div>
                        <div
                            className='flex justifyStart alignCenter'
                            onClick={() => props.openDelete(user.id)}
                            style={{ width: 100 }}
                        >
                            <img src={DeleteIcon} alt='delete_icon' height={32} width={32} />
                            <h4 style={{ marginRight: 12 }}>حذف کریں</h4>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Table;
